import { Box } from '@mui/material';
import i18n from '../../i18n';
import CardView from '../../component/card/card-view';
import TableComponent from '../../component/table/table.component';
import { useTranslation } from 'react-i18next';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { MobxObjectsManager } from '../mobx-objs/mobx-manager';
import { TopBarState } from '../../component/top-bar/top-bar-state';
import { useEffect } from 'react';
import { ProductListState } from './product-list-state';
import { WarrantI18N } from '../../models';
import ButtonComponent from '../../component/button/button.component';
import Product from './product';
import { ProductState } from './product-state';
import { formatEUR } from '../../constants/tool.fn';
import { getAuthPointI18n } from '../../constants/tool-auth-point';

// 经销商管理列表组件
const ProductListPage = observer(() => {
    useTranslation();

    // 使用数据管理
    const productListData = useLocalObservable(() => new ProductListState());
    // 顶部栏数据
    const topBarState = MobxObjectsManager.get(TopBarState);

    // 解构数据
    const {
        productList,
        isTableLoading,
        dataTotal,
        showUnit,
        enterResellerDetailObj
    } = productListData;


    useEffect(() => {
        productListData.init();
        topBarState.updateProductionTitle('');
        return () => {
            MobxObjectsManager.remove(ProductListState);
        }
    }, []);

    /**
     * 授权点详情
     * @param row
     */
    const handleOpenDetail = async (row: WarrantI18N) => {
        productListData.updateProduct(row)
        productListData.setIsOpenDetail(true);
    }

    const tableHeadCell = [
        {
            id: 'name', label: i18n.t('global_text_name'),
            renderFunction: (row: WarrantI18N) => getAuthPointI18n(row.name || [])
        },
        {
            id: 'type', label: i18n.t('message_notify_page_type'), renderFunction: (row: WarrantI18N) => row.code?.includes('AUC') ? i18n.t('warrant_page_text_authorization_set') : i18n.t('warrant_page_text_authorization_scheme')
        },
        {
            id: 'price', label: `${i18n.t('general_text_price')} / ${i18n.t('warrant_page_text_one_year')}`, renderFunction: (row: WarrantI18N) => formatEUR(row.price || 0)
        },
        { id: 'code', label: i18n.t('warrant_page_text_authorization_points') },
        {
            id: 'description', label: i18n.t('restaurant_info_page_text_description'),
            renderFunction: (row: WarrantI18N) => getAuthPointI18n(row.description || [])
        },
        {
            id: 'action', label: '',
            renderFunction: (row: WarrantI18N) => {
                return (
                    <ButtonComponent action='VIEW' handleClick={() => handleOpenDetail(row)} />
                )
            }
        }
    ];
    // *********************
    // Extra Function
    // *********************


    // 渲染集团列表组件
    const RenderComponent = (): JSX.Element => {
        return (
            <Box>
                <TableComponent
                    {...{
                        showChecked: 0,
                        // 表格数据
                        list: productList ?? [],
                        // 开启表格自定义页脚
                        isUseCustomPagination: true,
                        // 表格头
                        headCellList: tableHeadCell,
                        // 表格加载
                        isTableLoading,
                        // 表格行可展开
                        hasExpand: false,
                        // 表格页脚
                        isPagination: true,
                        // 页脚表格数据总数
                        allCount: dataTotal,
                        // 默认50
                        rowsPerPage: 50,
                        // 开启折叠组件 防止选择展开按钮会框选到表格行复选框
                        isUseFold: true,
                        // 表格可编辑class类
                        extraClass: 'extraTable'
                    }}
                />

            </Box >
        )
    }


    const PanelFilter = observer((props: { product: WarrantI18N }) => {
        const { product } = props;
        // 产品数据管理
        const useAccountData = useLocalObservable(() => new ProductState({
            id: product._id,
            componentType: 'EDIT',
        }));
        return (
            <Product
                componentType={'EDIT'}
                useProductMobx={useAccountData}
                goBack={() => {
                    productListData.goBack();
                }}
            />
        )
    })
    // *********************
    // Render View
    // *********************

    return (
        showUnit ?
            (<CardView
                contentRender={<PanelFilter product={enterResellerDetailObj.product} />}
            />)
            :
            (<CardView
                {...{
                    className: `reseller-management-page`,
                    contentRender: RenderComponent(),
                }}
            />)
    )
})

export default ProductListPage;
